import { addMonths, format } from "date-fns";
import React, {
  Fragment,
  memo,
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useReducer,
  useRef,
  useState,
} from "react";
// Provider
import {
  AppContext,
  SET_ITEMSTATE,
  SET_PAGE_STATE,
  SocketCommand,
  checkMobile,
  socketManager,
} from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";

// UI
import { IC } from "../../resources/Assets";
import { Container, DateLayer, closeLayerFn, openLayerFn } from "../Layout";

// import _T_PRESCRIPTION from "../../resources/images/sub/prescription_img.jpg";

import { SUBS, SubMenu, TYPES_HISTORY, TypeMenu } from "./Menu";

// Network
import {
  PostApi201,
  PostApi204,
  PostApi205,
  PostApi252,
} from "../../modules/network/padoPost";

import { AlertDialogLayer } from "./Eocs.Layers";

// Map
import { useInView } from "react-intersection-observer";
import { NativeAction } from "../../modules/utils/HandleWs";
import {
  PeriodTypeChange,
  convertFormat,
} from "../../modules/utils/PeriodTypeChange";
import { userHabit } from "../../modules/utils/UserHabit";
import ArrowImage from "../../resources/images/icon/icon_arrow_right_min_dark.png";
import { commonFileUpload } from "../PersonalMedicalRecords/PmrLayout";
import { reLogin } from "../common/AutoLogin/AutoLogin";
import { MapView } from "../common/Modal/NaverMap";
import SkeletonPmr from "../common/Skeleton/SkeletonPmr";
import useTitle from "../../modules/hooks/useTitle";

const interfaceDateFormat = "yyyyMMdd";

const SET_PERIOD_INDEX = "SET_PERIOD_INDEX";
const SET_START_DATE = "SET_START_DATE";
const SET_END_DATE = "SET_END_DATE";

const initialState = {
  // periodIndex: 2,
  periodIndex: 1,
  startDate: convertFormat(PeriodTypeChange("year", 1), "yyyyMMdd"),
  endDate: convertFormat(PeriodTypeChange("year", 0), "yyyyMMdd"),
};

const reducer = (state, action) => {
  switch (action.type) {
    case SET_PERIOD_INDEX:
      return {
        ...state,
        periodIndex: action.periodIndex,
      };
    case SET_START_DATE:
      return {
        ...state,
        startDate: action.date,
      };
    case SET_END_DATE:
      return {
        ...state,
        endDate: action.date,
      };
  }
};

export default props => {
  useTitle("처방전_기록");
  const {
    auth,
    userinfo,
    cfg,
    phonecfg,
    dispatch,
    pageState,
    prscList,
    itemState,
  } = useContext(AppContext);
  const sub = SUBS[1];

  const [state, dispatch2] = useReducer(reducer, initialState);

  const [typeIndex, setTypeIndex] = useState(
    props.match.params.eocsType === "1" ? 1 : 0
  );
  const type = TYPES_HISTORY[typeIndex];

  // const [refreshState, setRefreshState] = useState(props.match.params.refreshState === "1" ? 1 : 0);
  const [pageIdx, setPageIdx] = useState(1);
  const [loading, setLoading] = useState(true);

  const [eocsList, setEocsList] = useState(null);
  const [totalCnt, setTotalCnt] = useState(0);

  const [locationInfo, setLocationInfo] = useState({});
  const [deleteTarget, setDeleteTarget] = useState({});

  const pxid = useRef("");
  const paperFlag = useRef("");

  const handleDate = useCallback((isStart, date) => {
    if (isStart === "1") {
      dispatch2({ type: SET_START_DATE, date: date });
    } else {
      dispatch2({ type: SET_END_DATE, date: date });
    }

    // reloadList();
  });

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleDialog = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".dialog-layer"));
  };
  // 다이얼로그 ]]

  // 지도 [[
  const [maps, setMaps] = useState({
    name: "",
    latitude: userinfo.userLat,
    longitude: userinfo.userLng,
  });

  const handleMaps = (name, latitude, longitude) => {
    setMaps({
      name: name,
      latitude: latitude,
      longitude: longitude,
    });
  };

  const handleMapLayer = (e, name, lat, lon, locationInfo) => {
    if (name === null || lat === null || lon === null) return;

    handleMaps(name, lat, lon);
    setLocationInfo(locationInfo);

    openLayerFn($(".map-view-layer"));

    e.stopPropagation();
  };
  // 지도 ]]

  const request252 = (userinfo, periodIndex, startDate, endDate, idx) => {
    let reqStartDate = "";
    let reqEndDate = format(new Date(), interfaceDateFormat);

    switch (periodIndex) {
      case 1:
        reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
        break;
      case 2:
        reqStartDate = format(addMonths(new Date(), -6), interfaceDateFormat);
        break;
      case 3:
        reqStartDate = format(addMonths(new Date(), -12), interfaceDateFormat);
        break;
      default:
        reqStartDate = startDate;
        reqEndDate = endDate;
        break;
    }

    if (
      reqStartDate !== "" &&
      reqEndDate !== "" &&
      reqStartDate <= reqEndDate
    ) {
      PostApi252(
        userinfo,
        cfg,
        phonecfg,
        typeIndex,
        reqStartDate,
        reqEndDate,
        idx
      )
        .then(res => {
          if (res.resultMsg === "SUCCESS" && res.totRow > 0) {
            if (
              periodIndex == 4 &&
              ($(".pick-num1").val() == "" || $(".pick-num2").val() == "")
            ) {
              setEocsList(null);
              // dispatch({ type: SET_PRSC_LIST, data: [] });
            } else {
              setEocsList(res.resultList);
              // dispatch({ type: SET_PRSC_LIST, data: res.resultList });
            }
          } else {
            setEocsList(null);
            // dispatch({ type: SET_PRSC_LIST, data: [] });
          }
          setLoading(false);
          setTotalCnt(res.totRow);
        })
        .catch(err => {
          console.log(err);
          // setEocsList(null);
          setLoading(false);
        });
    }
  };

  const handleCancelEocs = useCallback((e, paramPxId) => {
    pxid.current = paramPxId;

    openLayerFn($(".presc-delete-layer"));

    e.stopPropagation();
  }, []);

  const request204 = (periodIndex, startDate, endDate) => {
    PostApi204(userinfo, cfg, phonecfg, pxid.current, paperFlag.current)
      .then(res => {
        switch (res.resultMsg) {
          case "SUCCESS":
            switch (res.resultCode) {
              case "1":
                reloadList();
                break;
              case "0":
                handleDialog("처방전 취소", "처방전 취소에 실패하였습니다.");
                break;
              case "-1":
                handleDialog("처방전 취소", "취소된 내용이 없습니다.");
                break;
              default:
                handleDialog(
                  "처방전 취소",
                  "수신된 결과값 오류(" + res.resultCode + ")"
                );
                break;
            }
            break;
          case "DATA NOT CHANGED!!!":
            handleDialog("처방전 취소", "취소된 내용이 없습니다.");
            break;
          case "LOGOUT":
            break;
          default:
            break;
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleDeleteReady = useCallback((e, paramPxId, paramPaperFlag) => {
    pxid.current = paramPxId;
    paperFlag.current = paramPaperFlag;

    /////해당 처방전을 삭제하겠습니까? (취소버튼)
    //열기
    openLayerFn($(".medic-delete-layer"));

    e.stopPropagation();
  }, []);

  const request205 = (periodIndex, startDate, endDate) => {
    //처방전이 삭제 되었습니다. 열기
    PostApi205(userinfo, cfg, phonecfg, pxid.current, paperFlag.current)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          switch (res.resultCode) {
            case "1":
              openLayerFn($(".medic-delete-com-layer"));

              // 삭제 후 접수완료 처방전 리스트 다시 요청
              // request252(userinfo, periodIndex, startDate, endDate);
              // reloadList();
              // setLoading(true);

              for (let i = 0; i < parseInt(totalCnt); i++) {
                setDisplayList(
                  displayList.filter(e => e.pxid != parseInt(pxid.current))
                );
                setTotalCnt(totalCnt - 1);

                closeLayerFn($(".medic-delete-layer"));
              }

              break;
            case "0":
              handleDialog("처방전 삭제", "처방전 삭제에 실패하였습니다.");
              break;
            case "-1":
              handleDialog("처방전 삭제", "삭제된 내용이 없습니다.");
              break;
            default:
              handleDialog(
                "처방전 삭제",
                "수신된 결과값 오류(" + res.resultCode + ")"
              );
              break;
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const reloadList = () => {
    console.log("reloadList");
    resetPaging();

    if (loading) {
      request252(
        userinfo,
        state.periodIndex,
        state.startDate,
        state.endDate,
        pageIdx
      );
    }
  };

  const resetPaging = () => {
    setEocsList([]);
    setDisplayList([]);
    setLastIndex(1);
    setResetState(true);
    setLoading(true);
  };

  const putJsonData = (
    downType,
    fileName,
    downLink,
    userToken,
    pxId,
    zipCode
  ) => {
    // return {"downType":downType, "fileName":fileName, "downLink":downLink, "userToken":userToken, "pxId":pxId, "zipCode":zipCode}
    return {
      downType: downType,
      fileName: fileName,
      downLink: downLink,
      userToken: userToken,
      pxId: pxId,
      zipCode: zipCode,
      viewYN: "Y",
      reserved: "",
    };
  };

  const imsiDownLoad = (filePath, url, userToken, pxid, zipcode, paperFlag) => {
    handleEocsView(filePath, url, userToken, pxid, zipcode, paperFlag);

    $(".blue-box-area").prop("disabled", true);
    setTimeout(() => {
      $(".blue-box-area").prop("disabled", false);
    }, 3000);
  };

  const socketConnection = (trsmId, paperFlag, viewYn) => {
    let masterKey2 = paperFlag.toString() === "0" ? "P" : "E";

    commonFileUpload(
      reloadList,
      userinfo,
      trsmId + "!" + masterKey2,
      1,
      viewYn === "N" ? "N" : "Y",
      "EP",
      "전자처방전",
      "10"
    );
  };

  const handleEocsView = (
    filePath,
    url,
    userToken,
    pxid,
    zipcode,
    paperFlag
  ) => {
    try {
      if (filePath !== null && filePath.length > 0) {
        if (phonecfg.phoneOS === "ANDROID") {
          socketConnection(pxid, paperFlag);
        } else {
          socketConnection(pxid, paperFlag);
        }
      } else {
        // if (url !== null && url.length > 0) {
        if (phonecfg.phoneOS === "ANDROID") {
          socketConnection(pxid, paperFlag);
        } else {
          socketConnection(pxid, paperFlag);
        }
        // } else {
        //   handleDialog("", "처방전 관련 정보가 없습니다.");
        // }
      }
    } catch (e) {
      handleDialog("", "처방전 보기는 단말기에서만 동작됩니다.");
      // alert(e);
      return;
    }
  };

  const changeTimeIdx = idx => {
    setPageIdx(1);
    setLoading(true);
    setTypeIndex(idx);

    $("#confirmCheck").hide();
    dispatch({ type: SET_PAGE_STATE, data: { type: "share", state: 0 } });

    if (idx === 0) {
      userHabit(phonecfg, "PR021");
    } else {
      userHabit(phonecfg, "PR022");
    }
  };

  const clickBtnEvent = () => {
    // handleAlert();
    if (pageState.share != 1) {
      // setShareMode(1);
      $("#confirmCheck").show();
      dispatch({ type: SET_PAGE_STATE, data: { type: "share", state: 1 } });
    } else {
      // setShareMode(0);
      $("#confirmCheck").hide();
      dispatch({ type: SET_PAGE_STATE, data: { type: "share", state: 0 } });
    }
  };

  const resetChecked = () => {
    // $("input:checkbox").prop("checked", false);
    clickBtnEvent();
  };

  const checkedAll = () => {
    $("input:checkbox").prop("checked", true);
    $(".styleCheckI").addClass("on");
    $("#checkAll").hide();
    $("#unCheckAll").show();
  };

  const unCheckedAll = () => {
    // $(".styleCheckI").prop("checked", false);
    $("input:checkbox").prop("checked", false);
    $(".styleCheckI").removeClass("on");
    $("#checkAll").show();
    $("#unCheckAll").hide();
  };

  let userinfo2 = reLogin(auth, userinfo, dispatch);

  useEffect(() => {
    $("#confirmCheck").hide();
    dispatch({ type: SET_PAGE_STATE, data: { type: "share", state: 0 } });
  }, []);

  useEffect(() => {
    if (loading === false) {
      setLoading(true);
    }
  }, [state.periodIndex, typeIndex, state.startDate, state.endDate, pageIdx]);

  useEffect(() => {
    if (loading) {
      reloadList();
    }
  }, [loading]);
  // }, [state.periodIndex, typeIndex, state.startDate, state.endDate, pageIdx, loading]);

  useEffect(() => {
    userHabit(phonecfg, "PR021");
    NativeAction(phonecfg, "statusColor", "#b2bee6");
  }, [phonecfg.version]);

  const itemStateFn = () => {
    if (itemState.data != null) {
      const value = JSON.stringify(itemState.data);
      if (JSON.parse(value).command === "delete") {
        if (parseInt(JSON.parse(value).data[0].fileCnt) === 0) {
          for (let i = 0; i < JSON.parse(value).data.length; i++) {
            setDisplayList(
              displayList.filter(
                e => e.myPxIdx != parseInt(JSON.parse(value).data[i].masterKey)
              )
            );
            // setTotalCnt(JSON.parse(value).data.length - 1);
            setTotalCnt(parseInt(totalCnt) - 1);

            closeLayerFn($(".medic-delete-layer"));
          }
        }
      } else {
        for (let i = 0; i < JSON.parse(value).data.length; i++) {
          if (parseInt(JSON.parse(value).data[i].fileCnt) === 0) {
            setDisplayList(
              displayList.filter(
                e => e.pxid != parseInt(JSON.parse(value).data[i].masterKey)
              )
            );
            setTotalCnt(parseInt(totalCnt) - 1);

            closeLayerFn($(".medic-delete-layer"));
          }
        }
      }
    } else {
      reloadList();
    }
  };

  useEffect(() => {
    if (pageState.reload === 1) {
      setLoading(true);
    }
  }, [loading, displayList]);

  useEffect(() => {
    if (itemState.reload) {
      itemStateFn();

      dispatch({
        type: SET_ITEMSTATE,
        data: { type: "COMPLETE" },
      });
    }
  }, [itemState.reload]);

  useEffect(() => {
    if (checkMobile() === "ANDROID") {
      // window.java.rcvFromWeb("wn111");
    } else if (
      checkMobile() === "IOS" &&
      parseInt(phonecfg.version.split(".")[2]) >= 25
    ) {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "wn111",
        data: "wn111",
      });
    }
  }, []);

  const { ref, inView } = useInView();

  const [lastIndex, setLastIndex] = useState(1);
  const [displayList, setDisplayList] = useState([]);
  const [deleteState, setDeleteState] = useState(true);
  const [resetState, setResetState] = useState(true);

  const CPP = 20;

  const dataListPaging = () => {
    const tList =
      eocsList &&
      Array.isArray(eocsList) &&
      eocsList.filter(
        (i, index) => index >= (lastIndex - 1) * CPP && index < lastIndex * CPP
      );

    if (resetState) {
      setDisplayList(tList);
      setResetState(false);
    } else {
      setDisplayList([...(displayList ?? []), ...(tList ?? [])]);
    }
  };

  useLayoutEffect(() => {
    // if (eocsList && eocsList.length > 0) {
    if (eocsList && eocsList.length > 0) {
      dataListPaging();
    }
  }, [lastIndex, eocsList]);

  useEffect(() => {
    if (!eocsList || !Array.isArray(eocsList)) {
      // resetPaging();
      // return;
    } else if (inView && lastIndex * CPP < eocsList.length) {
      // 인터페이스 252 실행시 pageCnt, pageIdx가 초과한 경우 리스트를 안줘야함
      if (resetState === false) {
        setLastIndex(lastIndex + 1);
      } else {
        setLastIndex(1);
      }
    }
  }, [inView]);

  // 종이처방전 조회
  const paperView = data => {
    // masterKey2 E:전자처방전, P:종이처방전
    let masterKey2 = data.paperFlag.toString() === "0" ? "P" : "E";

    // bizSubType : 0 진료자료, 1 기타자료, 2 교육자료 , 3 제증명
    socketManager(SocketCommand.FILE_UPLOAD, undefined, {
      type: "download",
      userToken: userinfo.userToken.toString(),
      masterKeys: [
        {
          // masterKey1: data.pxid.toString(),
          masterKey1: data.pxid.toString(),
          masterKey2: masterKey2,
          masterKey3: "",
        },
      ],

      bizType: "EP",
      bizName: "",
      bizDtlType: "",
      viewYN: "Y",
      saveExtYN: "N",
      colorType: "PP",
      hsptSharYn: "Y",
      bizSubType: "4",
      redirectURL: "cnntHspt/1",
    });
  };

  // 처방전 삭제 웹소켓
  const fnConfirmLayer = () => {
    // masterKey2 E:전자처방전, P:종이처방전
    let masterKey2 = deleteTarget.paperFlag.toString() === "0" ? "P" : "E";

    // bizSubType : 0 진료자료, 1 기타자료, 2 교육자료 , 3 제증명
    socketManager(SocketCommand.FILE_UPLOAD, undefined, {
      type: "delete",
      userToken: userinfo.userToken.toString(),
      masterKeys: [
        {
          // masterKey1: deleteTarget.myPxIdx.toString(),
          masterKey1: deleteTarget.myPxIdx.toString(),
          masterKey2: masterKey2,
          masterKey3: "",
        },
      ],

      bizType: "EP",
      bizName: "",
      bizDtlType: "",
      viewYN: "N",
      saveExtYN: "N",
      colorType: "PP",
      hsptSharYn: "N",
      bizSubType: "4 ",
      redirectURL: "",
    });
  };

  /*
    웹에서 처방전 삭제 인터페이스를 호출하는 경우
    1. 종이처방전
    2. 다운로드 받지 않은 처방전
    3. 다운로드를 받았으나 파일 리스트가 존재하지 않는 처방전(계정통합)
  */
  const deleteAction = (periodIndex, startDate, endDate) => {
    if (
      deleteTarget.paperFlag.toString() === "0" ||
      deleteTarget.myPxIdx === "" ||
      (deleteTarget.myPxIdx != "" && deleteTarget.fileNm.length === 0)
    ) {
      request205(periodIndex, startDate, endDate);
    } else {
      fnConfirmLayer();
    }
  };

  return (
    <Fragment>
      <Container
        Title={type.label}
        goToUrl={"/"}
        bizType={"EP"}
        bizName={"전자처방전"}>
        <div className="contents sub grad">
          <SubMenu SUBS={SUBS} code={sub.code} phoneOs={phonecfg.phoneOS} />

          <div className="sub-contents" style={{ paddingBottom: "100px" }}>
            <Period
              dispatch={dispatch2}
              setLoading={setLoading}
              setEocsList={setEocsList}
              startDate={state.startDate}
              endDate={state.endDate}
            />

            <TypeMenu
              TYPES={TYPES_HISTORY}
              code={type.code}
              setTypeIndex={changeTimeIdx}
              typeIndex={typeIndex}
            />

            {!loading ? (
              typeIndex === 0 ? (
                displayList != null && displayList.length > 0 ? (
                  // displayList !== null ? (
                  <Ing
                    label={type.label}
                    eocsList={displayList}
                    totalCnt={totalCnt}
                    userToken={userinfo.userToken}
                    handleEocsView={imsiDownLoad}
                    handleCancelEocs={handleCancelEocs}
                    handleMapLayer={handleMapLayer}
                    clickBtnEvent={clickBtnEvent}
                    resetChecked={resetChecked}
                    checkedAll={checkedAll}
                    unCheckedAll={unCheckedAll}
                  />
                ) : (
                  <NothingIng />
                )
              ) : displayList != null && displayList.length > 0 ? (
                <End
                  label={type.label}
                  eocsList={displayList}
                  totalCnt={totalCnt}
                  userToken={userinfo.userToken}
                  handleEocsView={imsiDownLoad}
                  handleDeleteReady={handleDeleteReady}
                  handleMapLayer={handleMapLayer}
                  clickBtnEvent={clickBtnEvent}
                  resetChecked={resetChecked}
                  checkedAll={checkedAll}
                  unCheckedAll={unCheckedAll}
                  setDeleteTarget={setDeleteTarget}
                  paperView={paperView}
                  testFn={itemState}
                />
              ) : (
                <NothingEnd />
              )
            ) : (
              <SkeletonPmr />
            )}
          </div>
          <div ref={ref} />
        </div>
      </Container>

      <DateLayer handleDate={handleDate} />

      <ReceiptCancelLayer state={state} request204={request204} />
      {/* <PreviewLayer /> */}
      <DeleteLayer state={state} request205={deleteAction} />
      <DeleteCompleteLayer />
      <AlertDialogLayer title={dialog.title} msg={dialog.msg} />
      <MapView locationInfo={locationInfo} />
    </Fragment>
  );
};

const Period = memo(
  ({ dispatch, setLoading, setEocsList, startDate, endDate }) => {
    const [periodType, setPeriodType] = useState(1);

    useEffect(() => {
      //기간설정 버튼들
      // $(".date-setting-area .btns a").click(function () {
      // $(".date-setting-area .btns a").removeClass("on");
      // $(this).addClass("on");
      // var idx = $(this).index();
      // if (idx == 3) {
      //   //직접 기간설정
      //   $(".date-setting-area .date-input").slideDown("fast");
      // } else {
      //   $(".date-setting-area .date-input").slideUp("fast");
      // }
      // dispatch({ type: SET_PERIOD_INDEX, periodIndex: idx });
      // setEocsList(null);
      // setLoading(true);
      // });

      dispatch({ type: SET_PERIOD_INDEX, periodIndex: periodType });
      setEocsList(null);
      setLoading(true);
    }, [periodType]);

    // 0~3 idx 변경
    return (
      <div className="pr-section">
        <div className="date-setting-area">
          <div className="btns">
            <a
              onClick={() => setPeriodType(1)}
              className={`${periodType === 1 ? "on" : ""}`}>
              3개월
            </a>
            <a
              onClick={() => setPeriodType(2)}
              className={`${periodType === 2 ? "on" : ""}`}>
              6개월
            </a>
            <a
              onClick={() => setPeriodType(3)}
              className={`${periodType === 3 ? "on" : ""}`}>
              1년
            </a>
            <a
              onClick={() => setPeriodType(4)}
              className={`btn-selfinput ${periodType === 4 ? "on" : ""}`}>
              기간설정
            </a>
          </div>
          <div
            className="date-input"
            style={{ display: periodType === 4 ? "block" : "none" }}>
            <div className="round-bar">
              <div className="ipbox">
                <input
                  type="text"
                  placeholder="선택하세요."
                  name="startDate"
                  readOnly
                  className="date-picker-input pick-num1"
                  data-num="1"
                />
                <i></i>
              </div>
              <u>~</u>
              <div className="ipbox">
                <input
                  type="text"
                  placeholder="선택하세요."
                  name="endtDate"
                  readOnly
                  className="date-picker-input pick-num2"
                  data-num="2"
                />
                <i></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

const Ing = memo(
  ({
    label,
    eocsList,
    totalCnt,
    userToken,
    handleEocsView,
    handleCancelEocs,
    handleMapLayer,
    clickBtnEvent,
    resetChecked,
    checkedAll,
    unCheckedAll,
  }) => {
    const { pageState } = useContext(AppContext);

    return (
      <div className="pr-section">
        <div className="sub-title">
          {label} <em className="pv">({totalCnt})</em>
          {/* {
                    pageState.share === 0 
                        ?   <BtnTypePill text={"선택"} onClick={()=>clickBtnEvent()} /> 
                        :   <Fragment>
                                <BtnTypePill text={"취소"} id="restoreMode" onClick={()=>resetChecked()} />
                                <BtnTypePill text={"전체선택"} id="checkAll" onClick={()=>checkedAll()} />
                                <BtnTypePill text={"전체해제"} id="unCheckAll" display="none" onClick={()=>unCheckedAll()} />
                            </Fragment>
                } */}
        </div>

        <div className="blueb-list-contain">
          {eocsList.map((m, i) =>
            m.pxStatus === "0" || m.pxStatus === "4" ? (
              <ReceiptDiv key={"rd_" + i}>
                {pageState.share === 1 ? (
                  // m.filePath != "" &&
                  <Fragment>
                    <ReceiptReady
                      key={i}
                      m={m}
                      userToken={userToken}
                      handleEocsView={handleEocsView}
                    />
                    <CheckBox m={m} listLength={eocsList.length} />
                  </Fragment>
                ) : (
                  <ReceiptReady
                    key={i}
                    m={m}
                    userToken={userToken}
                    handleEocsView={handleEocsView}
                  />
                )}
              </ReceiptDiv>
            ) : (
              (m.pxStatus === "1" ||
                m.pxStatus === "2" ||
                m.pxStatus === "3") && (
                <ReceiptDiv key={"rd_" + i}>
                  {pageState.share === 1 ? (
                    // m.filePath != "" &&
                    <Fragment>
                      <ReceiptIng
                        key={i}
                        m={m}
                        userToken={userToken}
                        handleEocsView={handleEocsView}
                        handleCancelEocs={handleCancelEocs}
                        handleMapLayer={handleMapLayer}
                      />
                      <CheckBox
                        key={"check" + i}
                        m={m}
                        listLength={eocsList.length}
                      />
                    </Fragment>
                  ) : (
                    <ReceiptIng
                      key={i}
                      m={m}
                      userToken={userToken}
                      handleEocsView={handleEocsView}
                      handleCancelEocs={handleCancelEocs}
                      handleMapLayer={handleMapLayer}
                    />
                  )}
                </ReceiptDiv>
              )
            )
          )}
        </div>
      </div>
    );
  }
);

const CheckBox = props => {
  const { m } = props;

  const clickCheckEvent = (e, pxid) => {
    let target = pxid;
    if ($("i[name=" + target + "]").attr("class") == "styleCheckI on") {
      $("i[name=" + target + "]").removeClass("on");
    } else {
      $("i[name=" + target + "]").addClass("on");
    }

    if (
      parseInt($("input:checkbox[name='targetCheck']").length) ===
      parseInt($(".on").length) - 3
    ) {
      $("#checkAll").hide();
      $("#unCheckAll").show();
    } else {
      $("#checkAll").show();
      $("#unCheckAll").hide();
    }
  };

  return (
    <label
      style={{
        position: "absolute",
        width: "40px",
        height: "40px",
        right: 0,
        top: "50%",
        transform: "translateY(-50%)",
      }}>
      <input
        type="checkbox"
        name="targetCheck"
        value={m.pxid + "!" + (m.paperFlag.toString() === "0" ? "P" : "E")}
        style={{ display: "none" }}
      />
      <i
        className="styleCheckI"
        name={m.pxid}
        style={{ width: "40px", height: "40px", right: 0 }}
        onClick={e => clickCheckEvent(e, m.pxid)}></i>
    </label>
  );
};

const ReceiptDiv = props => {
  const { children } = props;
  const { pageState } = useContext(AppContext);

  const styleDiv = {
    width: "100%",
  };

  const styleDivShare = {
    width: "100%",
    position: "relative",
  };

  return (
    <div style={{ padding: "0px !important" }}>
      <div style={pageState.share === 0 ? styleDiv : styleDivShare}>
        {children}
      </div>
    </div>
  );
};

const ReceiptReady = memo(({ i, m, userToken, handleEocsView }) => {
  const { pageState } = useContext(AppContext);

  const gotoReceipt = (e, pxid) => {
    _O.Open("/eocs/Receipt/" + pxid);
    e.stopPropagation();
  };

  const styleListShare = {
    width: "72%",
  };

  return (
    <Fragment>
      <div
        className="blue-box-area list"
        style={pageState.share === 1 ? styleListShare : {}}
        key={i}
        onClick={e =>
          handleEocsView(
            m.filePath,
            m.url,
            userToken,
            m.pxid,
            m.zipcode,
            m.paperFlag
          )
        }>
        <div className="tt-box">
          <div className="px-bx">
            <p>{m.hpName}</p>
            <span>
              {m.publishDate !== "" ? getDateFormat(m.publishDate) : null}
            </span>
          </div>
          <div className="top-label">
            <span>
              <i></i>
              {Alergy(m.allergyCheck)}
            </span>
          </div>
        </div>
        <div className="bb-box">
          교부번호. <em>{m.hpGrantNum}</em>
        </div>

        <div className="btns">
          <a onClick={e => gotoReceipt(e, m.pxid)}>조제문의</a>
          <a onClick={e => gotoReceipt(e, m.pxid)}>조제접수</a>
        </div>

        {/* 
                <div className="btns">
                    <a href={eocsUrl === null ? void 0 : eocsUrl} className="btn-open-prescription">처방전보기(URL:ep://)</a>
                    <a href={void 0} onClick={(e) => handleEocsView(m.filePath, m.url, userToken, m.pxid, m.hospital[0].zipcode)}>처방전보기(bridge)</a>
                </div> 
                */}
      </div>
    </Fragment>
  );
});

const ReceiptIng = memo(
  ({ i, m, userToken, handleEocsView, handleCancelEocs, handleMapLayer }) => {
    const { pageState, userinfo, cfg, phonecfg } = useContext(AppContext);

    const cancelEocs = e => {
      handleCancelEocs(e, m.pxid);
      e.stopPropagation();
    };

    const gotoReceipt = (e, pxid) => {
      _O.Open("/eocs/Receipt/" + pxid);
      // _O.Open('/eocs')
      e.stopPropagation();
    };

    // 조제가능일때 약국 즉시접수
    const request201 = () => {
      // 처방전 다운로드 안했을때 다운로드 실행
      // try {
      //   if (m.filePath == "") {
      //     socketConnection(m.pxid, 1, "N");
      //   }
      // } catch (e) {
      //   handleDialog("", "단말기에서 처방전 다운로드 됩니다.", "");
      // }

      PostApi201(userinfo, cfg, phonecfg, m.pxid, m.phKey, m.pxStatus)
        .then(res => {
          if (res.resultCode === "000") {
            if (pxStatus.current === "1") {
              //확인 : 접수가 완료되었습니다. 열기
              openLayerFn($(".receive-complete-layer"));
              setRequestEocs(Date());
            } else {
              _O.Open("/eocs/history/0");
            }
          }
        })
        .catch(err => {
          console.log(err);
          _O.Open("/eocs/Receipt/" + m.pxid);
          // _O.Open('/eocs')
          e.stopPropagation();
        });
    };

    const styleListShare = {
      width: "72%",
    };

    return (
      <div
        className="blue-box-area list"
        style={pageState.share === 1 ? styleListShare : {}}
        key={i}
        onClick={e =>
          handleEocsView(
            m.filePath,
            m.url,
            userToken,
            m.pxid,
            m.zipcode,
            m.paperFlag
          )
        }>
        <div className="tt-box">
          <div className="px-bx">
            <p>{m.hpName}</p>
            <span>
              {m.publishDate !== "" ? getDateFormat(m.publishDate) : null}
            </span>
          </div>
          <div className="top-label">
            <span>
              <i></i>
              {Alergy(m.allergyCheck)}
            </span>
          </div>
        </div>
        <div className="bb-box">
          교부번호. <em>{m.hpGrantNum}</em>
        </div>

        <div className="state-info">
          {m.pxStatus === "1" && <span>접수중</span>}
          {m.pxStatus === "2" && <span>문의중</span>}
          {m.pxStatus === "3" && <span>조제가능</span>}
          <b>{m.phName}</b>
          {m.perpCompSDT != "" && "(예상시간: " + m.perpCompSDT + ")"}
          <a
            onClick={e =>
              handleMapLayer(e, m.phName, m.latitude, m.longitude, {
                latitude: m.phLatitude,
                longitude: m.phLongitude,
                hpName: m.phName,
                address3: phAddress3,
                address4: phAddress4,
              })
            }
            className="location btn-open-map"></a>
          {m.pxStatus === "1" && (
            <a className="btn-cancel btn-open-presc-del" onClick={cancelEocs}>
              <i></i>취소
            </a>
          )}
        </div>

        {/* 
        - 문의 후 조제가능 상태일 때 타 약국 문의가 불가함
        - 조제접수 버튼을 클릭하면 문의했던 약국에 즉시 접수가 되어야 함
      */}
        {m.pxStatus === "3" && (
          <div className="btns">
            {/* <a onClick={(e) => gotoReceipt(e, m.pxid)}>조제문의</a> */}
            <a
              style={{ width: "100%", borderRadius: "8px", background: "#FFF" }}
              onClick={e => gotoReceipt(e, m.pxid)}>
              {/* onClick={e => request201()}> */}
              조제접수
            </a>
          </div>
        )}
      </div>
    );
  }
);

const End = memo(
  ({
    label,
    eocsList,
    totalCnt,
    userToken,
    handleEocsView,
    handleDeleteReady,
    handleMapLayer,
    clickBtnEvent,
    resetChecked,
    checkedAll,
    unCheckedAll,
    setDeleteTarget,
    paperView,
    testFn,
  }) => {
    const { pageState } = useContext(AppContext);

    const styleListShare = {
      width: "72%",
    };

    return (
      <div className="pr-section">
        <div className="sub-title">
          {label} <em className="pv">({totalCnt})</em>
          {/* {
              pageState.share === 0 
                  ?   <BtnTypePill text={"선택"} onClick={()=>clickBtnEvent()} /> 
                  :   <Fragment>
                          <BtnTypePill text={"취소"} id="restoreMode" onClick={()=>resetChecked()} />
                          <BtnTypePill text={"전체선택"} id="checkAll" onClick={()=>checkedAll()} />
                          <BtnTypePill text={"전체해제"} id="unCheckAll" display="none" onClick={()=>unCheckedAll()} />
                      </Fragment>
          }*/}
        </div>

        <div className="shadow-boxes-list">
          {/* <div onClick={() => testFn()}>테스트</div> */}
          {eocsList.map((m, i) => (
            <Fragment>
              {pageState.share === 1 ? (
                <ReceiptDiv>
                  <EndPrscList
                    key={i}
                    m={m}
                    i={i}
                    handleEocsView={handleEocsView}
                    handleMapLayer={handleMapLayer}
                    getDateFormat={getDateFormat}
                    handleDeleteReady={handleDeleteReady}
                  />
                  <CheckBox
                    key={"check" + i}
                    m={m}
                    listLength={eocsList.length}
                  />
                </ReceiptDiv>
              ) : (
                <ReceiptDiv>
                  {/* {m.paperFlag === "0" ? ( */}
                  <EndPrscList2
                    key={i}
                    m={m}
                    i={i}
                    handleEocsView={handleEocsView}
                    handleMapLayer={handleMapLayer}
                    getDateFormat={getDateFormat}
                    handleDeleteReady={handleDeleteReady}
                    setDeleteTarget={setDeleteTarget}
                    paperView={paperView}
                  />
                  {/* ) : (
                    <EndPrscList
                      key={i}
                      m={m}
                      i={i}
                      handleEocsView={handleEocsView}
                      handleMapLayer={handleMapLayer}
                      getDateFormat={getDateFormat}
                      handleDeleteReady={handleDeleteReady}
                    />
                  )} */}
                </ReceiptDiv>
              )}
            </Fragment>
          ))}
        </div>
      </div>
    );
  }
);

const EndPrscList = props => {
  const {
    m,
    i,
    handleEocsView,
    handleMapLayer,
    getDateFormat,
    handleDeleteReady,
  } = props;
  const { pageState, userinfo } = useContext(AppContext);

  const styleListShare = {
    width: "72%",
    marginBottom: "15px",
  };
  return (
    <div
      className={m.paperFlag === "0" ? "paper" : "epresc"}
      style={pageState.share === 1 ? styleListShare : {}}
      key={i}
      onClick={e =>
        handleEocsView(
          m.filePath,
          m.url,
          userinfo.userToken,
          m.pxid,
          m.zipcode,
          m.paperFlag
        )
      }>
      <div className="hf-area">
        <div>
          <p>{m.hpName}</p>
          <span>{m.publishDate !== "" && getDateFormat(m.publishDate)}</span>
        </div>
        <div>
          <p>
            {m.phName !== undefined && m.phName}
            {m.paperFlag === "1" && m.phName !== undefined && (
              <a
                onClick={e =>
                  handleMapLayer(e, m.phName, m.phLatitude, m.phLongitude, {
                    latitude: m.phLatitude,
                    longitude: m.phLongitude,
                    hpName: m.phName,
                    address3: m.phAddress3,
                    address4: m.phAddress4,
                  })
                }
                className="location btn-open-map"></a>
            )}
          </p>
          <span>{m.publishDate !== "" && getDateFormat(m.recipCompDate)}</span>
          {m.reasonNoPrep !== null && m.reasonNoPrep !== "" && <br></br>}
          {m.reasonNoPrep !== null && m.reasonNoPrep !== "" && (
            <span>{m.reasonNoPrep}</span>
          )}
        </div>
      </div>
      <div className="under-num">
        {m.paperFlag === "1" && (
          <p>
            교부번호. <em>{m.hpGrantNum}</em>
          </p>
        )}
        <a
          href={void 0}
          className="delete btn-open-del-layer"
          onClick={e => handleDeleteReady(e, m.pxid, m.paperFlag)}>
          <i></i>삭제
        </a>
      </div>
    </div>
  );
};

const EndPrscList2 = (props) => {
  const {
    m,
    i,
    handleEocsView,
    handleMapLayer,
    getDateFormat,
    handleDeleteReady,
    setDeleteTarget,
    paperView,
  } = props;
  const { pageState, userinfo } = useContext(AppContext);

  const styleListShare = {
    width: "72%",
    marginBottom: "15px",
    padding: "0px",
  };

  const styleListDefault = {
    padding: "0px",
  };

  const settingReturnDate = (dateParam) => {
    // 현재 날짜 시간 기본설정
    const returnYear = dateParam.substring(0, 4);
    const returnMonth = dateParam.substring(4, 6);
    const returnDate = dateParam.substring(6, 8);

    const toDay = new Date(returnYear + "/" + returnMonth + "/" + returnDate);
    //요일 설정
    const week = new Array("일", "월", "화", "수", "목", "금", "토");

    let defaultDay = week[toDay.getDay()];
    return returnYear + "." + returnMonth + "." + returnDate + "(" + defaultDay + ")";
  };
  return (
    <div
      className={m.paperFlag.toString() === "0" ? "paper" : "epresc"}
      style={pageState.share === 1 ? styleListShare : styleListDefault}
      key={i}
    >
      <div
        style={{ padding: "20px" }}
        onClick={(e) =>
          m.paperFlag.toString() === "1"
            ? handleEocsView(
                m.filePath,
                m.url,
                userinfo.userToken,
                m.pxid,
                m.zipcode,
                m.paperFlag.toString()
              )
            : paperView(m)
        }
      >
        <div style={{ display: "flex" }}>
          {/* <p style={{ marginRight: "10px", fontWeight: "600", color: "#7A7A7A", }}> */}
          <p
            style={{
              marginRight: "10px",
              fontWeight: "600",
              color: "#7A7A7A",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "50%",
            }}
          >
            [처방] {m.hpName}
          </p>
          <span style={{ color: "#7A7A7A" }}>
            {m.publishDate !== "" && getDateFormat(m.publishDate)}
          </span>
          <img
            src={ArrowImage}
            style={{ width: "6.5px", height: "11.48px", marginLeft: "auto", marginTop: "4px" }}
          />
        </div>
        <div style={{ display: "flex" }}>
          <p
            style={{
              marginRight: "10px",
              fontWeight: "600",
              color: "#7A7A7A",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "50%",
            }}
          >
            [조제] {m.phName !== "" ? m.phName : "-"}
          </p>

          <span style={{ color: "#7A7A7A" }}>
            {m.recipCompDate !== "" && getDateFormat(m.recipCompDate)}
          </span>
        </div>
        {m.paperFlag.toString() === "1" && (
          <div style={{ display: "flex" }}>
            <p style={{ color: "#7A7A7A" }}>
              교부번호. <em>{m.hpGrantNum}</em>
            </p>
            <div
              style={{
                borderRadius: "10px",
                backgroundColor: "#93c6e6",
                textAlign: "center",
                padding: "3px 8px",
                fontSize: "10px",
                fontWeight: "400",
                color: "#fff",
                marginLeft: "8px",
              }}
            >
              전자처방전
            </div>
          </div>
        )}
        {m.paperFlag.toString() == "2" && (
          <div style={{ display: "flex" }}>
            <div
              style={{
                borderRadius: "10px",
                backgroundColor: "#6B65DE",
                textAlign: "center",
                padding: "3px 8px",
                fontSize: "10px",
                fontWeight: "400",
                color: "#fff",
              }}
            >
              비대면진료 처방전
            </div>
          </div>
        )}
      </div>

      <div style={{ display: "flex" }}>
        <div className="under-num" style={{ width: "100%", paddingTop: "0px" }}>
          <a
            className="delete btn-open-del-layer"
            style={{
              position: "relative",
              right: "0px",
              bottom: "0px",
              textAlign: "center",
              borderTop: "1px solid #d9d9d9",
            }}
            onClick={(e) => {
              handleDeleteReady(e, m.pxid, m.paperFlag.toString());
              setDeleteTarget(m);
            }}
          >
            <i />
            삭제
          </a>
        </div>

        {m.paperFlag.toString() === "0" && (
          <div className="under-num" style={{ width: "100%", paddingTop: "0px" }}>
            <a
              className="modify btn-open-del-layer"
              style={{
                position: "relative",
                right: "0px",
                bottom: "0px",
                textAlign: "center",
                borderTop: "1px solid #d9d9d9",
                borderLeft: "1px solid #d9d9d9",
              }}
              onClick={(e) =>
                prscUploadNew(
                  "U",
                  m.pxid,
                  settingReturnDate(m.publishDate),
                  settingReturnDate(m.recipCompDate),
                  m.hpName,
                  m.phName,
                  m.fileNm
                )
              }
            >
              <i />
              수정
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

const ReceiptCancelLayer = ({ state, request204 }) => {
  useEffect(() => {
    // //열기
    // $(".btn-open-presc-del").click(function(){
    //     openLayerFn($(".presc-delete-layer"));
    // });

    //닫기
    $(".presc-delete-layer .tbns-area a").click(function () {
      closeLayerFn($(".presc-delete-layer"));
    });
  }, []);

  return (
    <div className="blacklayer-container presc-delete-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div>
          <div className="blgrn-box vertical priv">
            <div className="blgr-title"></div>

            <div className="save-question-box">해당 처방전을 취소하겠습니까?</div>

            <div className="tbns-area">
              <a href={void 0} className="btn-round gray">
                취소
              </a>
              <a
                href={void 0}
                className="btn-round wht"
                onClick={(e) => request204(state.periodIndex, state.startDate, state.endDate)}
              >
                확인
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DeleteLayer = ({ state, request205 }) => {
  useEffect(() => {
    //확인, 취소
    $(".medic-delete-layer .tbns-area a").click(function () {
      closeLayerFn($(".medic-delete-layer"));
    });
  }, []);

  return (
    <div className="blacklayer-container medic-delete-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div>
          <div className="blgrn-box vertical priv">
            <div className="blgr-title"></div>

            <div className="save-question-box">해당 처방전을 삭제하겠습니까?</div>

            <div className="tbns-area">
              <a className="btn-round gray">취소</a>
              <a
                className="btn-round wht"
                onClick={(e) => request205(state.periodIndex, state.startDate, state.endDate)}
              >
                확인
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DeleteCompleteLayer = (props) => {
  useEffect(() => {
    //처방전이 삭제 되었습니다. 닫기
    $(".medic-delete-com-layer .tbns-area a").click(function () {
      closeLayerFn($(".medic-delete-com-layer"));
    });
  }, []);

  return (
    <div className="blacklayer-container medic-delete-com-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div>
          <div className="blgrn-box vertical priv">
            <div className="blgr-title">처방전 삭제</div>

            <div className="save-question-box">처방전이 삭제 되었습니다.</div>

            <div className="tbns-area">
              <a href={void 0} className="btn-round wht">
                확인
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const NothingIng = memo((props) => {
  return (
    <div className="pr-section">
      <div className="nothing-box">
        <div>
          <img src={IC.empty.eocsIng} alt="" />
          <p>현재 접수된 처방전이 없습니다. </p>
        </div>
      </div>
    </div>
  );
});

const NothingEnd = memo((props) => {
  return (
    <div className="pr-section">
      <div className="nothing-box">
        <div>
          <img src={IC.empty.eocsEnd} alt="" />
          <p>완료된 처방기록이 없습니다.</p>
        </div>
      </div>
    </div>
  );
});

const getDateFormat = (dateStr) => {
  if (dateStr == null || dateStr.length !== 8) return dateStr;

  return dateStr.length != 0 && dateStr.length == 8
    ? dateStr.substring(0, 4) + "." + dateStr.substring(4, 6) + "." + dateStr.substring(6, 8)
    : "";
};

const Alergy = (type) => {
  switch (type.toString()) {
    case "-1":
      return "체크안함";
    case "0":
      return "알레르기 위험";
    case "1":
      return "알레르기 안전";
    case "2":
      return "알레르기 임산부 위험";
    case "3":
      return "알레르기 임산부 주의";
    case "4":
      return "알레르기 임산부 안전";
    default:
      return "";
  }
};

export const prscUploadNew = (procType, seqNo, prscDt, prptnDt, hsptNm, pharmNm, fileNm) => {
  socketManager(SocketCommand.PRSC_DNLD_MULTI, "", {
    procType: procType.toString(),
    seqNo: parseInt(seqNo),
    prsctDt: prscDt.toString(),
    prptnDt: prptnDt.toString(),
    hsptNm: hsptNm.toString(),
    pharmNm: pharmNm.toString(),
    fileNm: fileNm,
  });
};
